import { PAPIERS_DE_FICHE, TYPES_DE_FICHE } from './listes.js';
/** Ni la bulle ni son projet n'ont rien choisi : Classique, feuille blanche. */
export const FICHE_PAR_DEFAUT = Object.freeze({ type: 'classique', papier: 'blanche' });
/**
 * **Le papier de chaque type** (chantier reglages-de-la-fiche, modification 01 ; maquette du carnet
 * `fiche-quatre-types.html`) : une Note sur feuille à lignes, une Contact en bristol, une Plan à
 * carreaux. Écrit une fois ici. Seule une Classique choisit son papier.
 */
export const PAPIER_DU_TYPE = Object.freeze({
    note: 'lignes',
    contact: 'bristol',
    plan: 'carreaux',
});
/** La valeur si elle est dans sa liste, sinon `null` : une valeur inconnue vaut « rien de choisi ». */
function dansLaListe(valeur, liste) {
    return liste.includes(valeur ?? '') ? valeur : null;
}
/**
 * Le type et le papier par défaut des fiches d'un projet : `null`, ou une valeur hors de sa
 * liste, vaut Classique, feuille blanche. Aucune migration ne transforme les projets déjà là.
 */
export function fichesDuProjet(projet) {
    return {
        type: dansLaListe(projet?.typeParDefaut, TYPES_DE_FICHE) ?? FICHE_PAR_DEFAUT.type,
        papier: dansLaListe(projet?.papierParDefaut, PAPIERS_DE_FICHE) ?? FICHE_PAR_DEFAUT.papier,
    };
}
/**
 * **Le type et le papier d'une fiche**, la règle écrite une fois. Le type : celui de la bulle,
 * sinon celui de son projet, sinon Classique. Le papier : une Note, une Contact ou une Plan porte
 * celui de son type (`PAPIER_DU_TYPE`) ; une Classique, le sien, sinon celui du projet, sinon la
 * feuille blanche (chantier reglages-de-la-fiche, modification 01). Le papier choisi reste en base
 * et revient quand la fiche repasse en Classique. Une valeur hors de sa liste vaut « rien de
 * choisi » et passe au suivant, l'écran ne reçoit jamais un type qu'il ne sait pas montrer.
 */
export function ficheDeLaBulle(bulle, projet) {
    const duProjet = fichesDuProjet(projet);
    const type = dansLaListe(bulle.typeDeFiche, TYPES_DE_FICHE) ?? duProjet.type;
    if (type !== 'classique')
        return { type, papier: PAPIER_DU_TYPE[type] };
    return { type, papier: dansLaListe(bulle.papierDeFiche, PAPIERS_DE_FICHE) ?? duProjet.papier };
}
/**
 * Le type et le papier d'une bulle tels que la base les garde, pour la feuille : `null` quand elle
 * n'a rien choisi (« Comme le projet »), et aussi pour une valeur hors de sa liste.
 */
export function ficheEnBase(bulle) {
    return {
        typeDeFiche: dansLaListe(bulle.typeDeFiche, TYPES_DE_FICHE),
        papierDeFiche: dansLaListe(bulle.papierDeFiche, PAPIERS_DE_FICHE),
    };
}
